import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import NavigationBar from "../components/layout/NavigationBar";
import Footer from "../components/layout/Footer";
import DealsContainer from "./dealsContainer";
import JustPrisaContainer from "./justPrisaContainer";
import HaklaiContainer from "./haklaiContainer";
import MyDealsContainerNoSP from "./myDealsContainerNoSP";
import UsersManagement from "../components/managerComponents/usersManagement";
import AdminRoute from "../auth/adminGuard";
import SalesRoute from "../auth/salesGuard";
import AdminContainer from "./adminContainer";
import { isFeatureEnabled } from "../services/utils/featureAccess";
import CourseCampaign from "../components/course-campaign/CourseCampaign";

class ApplicationCon extends Component {
  state = { isDealsPageLoading: true };

  handleDealsLoadingChange = (isDealsPageLoading) => {
    this.setState((previous) => previous.isDealsPageLoading === isDealsPageLoading ? null : { isDealsPageLoading });
  };

  render() {
    const hasHaklaiAccess = isFeatureEnabled(this.props.enabledFeatures, "BTAX_HAKLAI_DEALS");
    const pathname = this.props.location.pathname;
    const isDealsPage = pathname === "/" || pathname.startsWith("/my-deals");
    const pageReady = !this.props.loaderOn && (!isDealsPage || !this.state.isDealsPageLoading);

    return (
      <React.Fragment>
        <NavigationBar />
        <CourseCampaign pageReady={pageReady} />
        <div className="container pb-70 center">
          <Switch>
            <Route path="/my-deals" render={(routeProps) => <MyDealsContainerNoSP {...routeProps} onLoadingChange={this.handleDealsLoadingChange} />} />
            <Route path="/deal/:tab/:dealId" component={DealsContainer} />
            <Route path="/just-prisa/:tab/:dealId" component={JustPrisaContainer} />
            {hasHaklaiAccess ? (
              <Route path="/haklai/:tab/:dealId" component={HaklaiContainer} />
            ) : (
              <Route path="/haklai/:tab/:dealId">
                <Redirect to="/my-deals" />
              </Route>
            )}
            <SalesRoute path="/users-management/:searchByCardNum?" component={UsersManagement} />
            <AdminRoute path="/admin" component={AdminContainer} />
            <Route path="/">
              <Redirect to="/my-deals" />
            </Route>
          </Switch>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    enabledFeatures: state.loggedinReducer.enabledFeatures,
    loaderOn: state.appSettingsReducer.loaderOn
  };
};

export default connect(mapStateToProps)(ApplicationCon);
